import styled from 'styled-components';

import { WEDO_DEFAULT_WIDTH } from '~/styles/breakpoints';

export const Wrapper = styled.div`
  min-height: 100%;
  display: flex;
  flex-direction: column;
`;
export const Container = styled.div`
  flex: 1;
  display: flex;
`;

export const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding-bottom: 100px;
`;

export const Body = styled.div`
  width: 100%;
  height: 100%;
  max-width: ${WEDO_DEFAULT_WIDTH};
  margin: 0 auto;
`;
